"use client";

import dynamic from "next/dynamic";

const Carousel = dynamic(() => import("./DigitalSignageGalleryCarousel"), {
  loading: () => <div className="h-[30vh] bg-gray-100 animate-pulse" />,
});

interface DigitalSignageGalleryCarouselProps {
  className?: string;
}

export default function DigitalSignageGalleryCarouselClient(props: DigitalSignageGalleryCarouselProps) {
  return <Carousel {...props} />;
}

